import { ElMessage } from 'element-plus/es'

// 从加载好的skd获取地址，匹配province，其他作为address传入
export const openKakooAddr = async (model:any, provinces:any, rest:any[] = []) => {
  // 匹配默认
  const props = ['province', 'postalCode', 'address'].map((v, i) => rest[i] || v)
  if (window.daum) {
    const handle = (data:any) => {
      const { address, zonecode } = data
      if (address) {
        const [province, ...rest] = address.split(' ')
        // model.province
        const temp = provinces.find((v:any) => v.nameKr === province)
        if (temp) {
          model[props[0]] = temp.intAreaId
          // 英文省份
          model.areaEn = temp.nameEn
          model[props[1]] = zonecode
          model[props[2]] = rest.join(' ')
        } else {
          ElMessage.error('')
        }
      }
    }
    new window.daum.Postcode({
      oncomplete: handle
    }).open()
  }
}
